import { useMemo } from 'react';
import { AdjustmentGridViewProps } from 'components';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps, AdjustmentDetail } from 'types';

export default function useAdjustmentCategory(adjustments: AdjustmentDetail[],
    adjustmentTypeMap: Map<AdjustmentType, AdjustmentCategoryGridProps>, selectedCategory: AdjustmentType): AdjustmentGridViewProps {

    const props = useMemo(() => adjustmentTypeMap.get(selectedCategory) ?? {
        adjustmentTypes: [],
        category: 0 as AdjustmentType,
        dataItemKey: 'na',
        gridColumns: [],
        selectMode: 'single'
    } as AdjustmentCategoryGridProps, [adjustmentTypeMap, selectedCategory]);

    const filteredAdjustments = useMemo(
        () => adjustments.filter(item => props.adjustmentTypes.includes(item.adjustmentTypeId)),
        [adjustments, props]
    );
    
    return {
        adjustments: filteredAdjustments,
        ...props
    };
}